import { Organization } from '@models/Organization';

import ColaboradoresScreen from './ColaboradoresScreen';

interface ColaboradoresScreenProps {
    org: Organization;
}

const ColaboradoresControlBoard: React.FC<ColaboradoresScreenProps> = ({ org }) => {
    return <ColaboradoresScreen org={org} />;
};

export default ColaboradoresControlBoard;
